document.addEventListener("DOMContentLoaded", function() {
    const newborn_optionWrap = document.querySelector(".cSection_content_main");
    const addBtn = newborn_optionWrap.querySelector(".option_ATC_btn");

    // toggle dropdown based on checkbox state
    newborn_optionWrap.querySelectorAll(".product_option").forEach(function(opt) {
        const checkbox = opt.querySelector(".product_option_checkbox");
        const select = opt.querySelector(".optionSelect");

        if (checkbox && select) {
        // initialize state
        select.disabled = !checkbox.checked;

        // toggle on change
        checkbox.addEventListener("change", function() {
            select.disabled = !this.checked;
            if (!this.checked) {
            select.selectedIndex = 0; // reset dropdown when unchecked
            }
        });
        }
    });
    // toggle dropdown based on checkbox state


    // multi product Ajax add to curt functionality
    addBtn.addEventListener("click", function() {
      let itemsToAdd = [];

      newborn_optionWrap.querySelectorAll(".product_option").forEach(function(opt, i) {
        const checkbox = opt.querySelector(".product_option_checkbox");
        const select = opt.querySelector(".optionSelect");

        // console.log("Option", i, { 
        //     checkbox, 
        //     checked: checkbox ? checkbox.checked : "not found", 
        //     select, 
        //     value: select ? select.value : "not found" 
        // });

        if (checkbox && checkbox.checked && select && select.value) {
          itemsToAdd.push({
            id: parseInt(select.value), 
            quantity: 1
          });
        }
      });


      if (itemsToAdd.length > 0) {
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ 
            items: itemsToAdd,
            sections: Array.from(document.querySelector('cart-drawer').getSectionsToRender()).map(section => section.id),
            sections_url: window.location.pathname
          })
        })  
        .then(res => res.json())
        .then(data => {
          console.log("Added to cart:", data);
                const cartDrawer = document.querySelector('cart-drawer');
                cartDrawer.renderContents(data);
                cartDrawer.classList.remove('is-empty').add("active");
                setTimeout(() => cartDrawer.open(), 750);
          // Optionally update cart UI here or show success message
          alert("Items added to cart!");
        })
        .catch(err => console.error("Error adding to cart:", err));
      } else {
        alert("Please select at least one product.");
      }
      
    });
    // multi product Ajax add to curt functionality


    // Print function  
    window.printResult = function () {
        const source = document.getElementById("print_list_info");
        if (!source) return;

        const clone = source.cloneNode(true);

        // Remove buttons in print
        clone.querySelectorAll("button").forEach(btn => btn.remove());

        /* ===============================
        CHECKBOX VISUALS (WORKING)
        =============================== */
        clone.querySelectorAll('input[type="checkbox"]').forEach((cb, i) => {
            const originalCb = source.querySelectorAll('input[type="checkbox"]')[i];

            const box = document.createElement("span");
            box.style.display = "inline-block";
            box.style.width = "14px";
            box.style.height = "14px";
            box.style.border = "1px solid #000";
            box.style.marginRight = "8px";
            box.style.verticalAlign = "middle";
            box.style.textAlign = "center";
            box.style.lineHeight = "14px";
            box.style.fontSize = "12px";

            if (originalCb && originalCb.checked) {
                box.textContent = "✔";
            }

            cb.replaceWith(box);
        });

        /* ===============================
        PRODUCT OPTION LOGIC (FIXED)
        =============================== */
        const originalOptions = source.querySelectorAll(".product_option");
        const clonedOptions = clone.querySelectorAll(".product_option");

        clonedOptions.forEach((clonedOpt, i) => {
            const originalOpt = originalOptions[i];
            if (!originalOpt) return;

            const originalCheckbox = originalOpt.querySelector(".product_option_checkbox");
            const originalSelect = originalOpt.querySelector("select");

            const clonedSelect = clonedOpt.querySelector("select");

            // Always remove select UI from print
            if (clonedSelect) clonedSelect.remove();

            // If checked → print selected value
            if (
                originalCheckbox &&
                originalCheckbox.checked &&
                originalSelect &&
                originalSelect.value
            ) {
                const selectedText =
                    originalSelect.options[originalSelect.selectedIndex].textContent.trim();

                const valueLine = document.createElement("div");
                valueLine.textContent = "• " + selectedText;
                valueLine.style.marginLeft = "22px";
                valueLine.style.marginTop = "4px";

                clonedOpt.appendChild(valueLine);
            }
        });

        /* ===============================
        PRINT WINDOW
        =============================== */
        const printWindow = window.open("", "", "width=900,height=650");

        printWindow.document.write(`
            <html>
            <head>
                <title>Print List</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        padding: 20px;
                    }

                    h2, h3 {
                        margin-bottom: 16px;
                    }

                    /* Base spacing for every item */
                    .option_name,
                    .product_option {
                        margin-bottom: 12px;
                        line-height: 1.5;
                    }
                    
                    .content_inner .option_name{
                        padding-left: 22px;
                    }

                    /* Checkbox + label row */
                    .option_name span,
                    .product_option span {
                        margin-right: 8px;
                    }

                    /* Selected value line */
                    .product_option > div {
                        margin-top: 6px;
                        margin-left: 22px;
                    }
                </style>
            </head>
            <body>
                ${clone.innerHTML}
            </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.focus();

        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 300);
    };

    // Print function 
});